import script from "./wait-data-load.vue?vue&type=script&setup=true&lang=js"
export * from "./wait-data-load.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__